/**
 * Service for the CGU (Conditions Générales d'Utilisation) singleton.
 */
import useApi from '../utils/api';

class CguContentService {
  #prefix = '/cguContent';

  fetchCguContent = () => {
    return useApi.get(this.#prefix);
  };

  updateCguContent = (data) => {
    return useApi.put(this.#prefix, data);
  };
}

export default new CguContentService();
